import { clientApi } from "@api";
import {
  ComponentPagination,
  SearchFilter,
  SelectedFilter,
  StyledListPage,
  ComponentHeader,
  StyledInnerListPage,
} from "@components";

import { PATH_CLIENT_CREATE, patientFilter, enumFilter, initPage, PATH_CDIC_PATIENT } from "@configs";
import { IClient, IPagination, IRedeemCoupon } from "@interfaces";
import { PatientTable } from "@modules";
import { selectApp, setLoading } from "@redux";
import { useNotify } from "@utils";

import { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";

export const PagePatient = () => {
  // hook
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const { success, error } = useNotify();
  const { mobile } = useSelector(selectApp);
  // state
  const [page, setPage] = useState<IPagination>(initPage);
  const [total, setTotal] = useState<number>(0);
  const [data, setData] = useState<IRedeemCoupon[]>([]);
  const [filters, setFilters] = useState<enumFilter | string>("");
  const [text, setText] = useState<string>("");
  const [date, setDate] = useState<string[]>([]);
  const { pathname } = useLocation();

  useEffect(() => {
    fetchClient();
  }, [page, text, date]);

  const fetchClient = async () => {
    let res;
    try {
      dispatch(setLoading(true));
      if (pathname === PATH_CDIC_PATIENT) {
        res = await clientApi.cdicClients({
          page: page.page,
          limit: page.limit,
          searchColumn: filters,
          search: text,
          startDate: date[0],
          endDate: date[1],
        });
      } else {
        res = await clientApi.clients({
          page: page.page,
          limit: page.limit,
          searchColumn: filters,
          search: text,
          startDate: date[0],
          endDate: date[1],
        });
      }
      setData(res.data?.data);
      setTotal(res.data?.nTotal);
      success(t("message.fetch.success"));
    } catch (err: any) {
      error(t("message.fetch.fail"));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };
  const handleDateFilter = (dates: null | (Dayjs | null)[], dateStrings: string[]) => {
    setDate(dateStrings);
  };
  const handlePagination = (current: number, size: number) => {
    setPage({ ...page, page: current, limit: size });
  };

  const goToCreate = () => history.push(PATH_CLIENT_CREATE);
  const changeFilter = (value: string) => setFilters(value);
  const searchText = (value: string) => setText(value);
  const handleClearSearch = () => {
    setText("");
    setFilters("");
  };
  const handleClearDate = () => setDate([]);

  return (
    <>
      <ComponentHeader title={ pathname === PATH_CDIC_PATIENT ? t("page.cdic_clients") : t("page.client_information")} />
      <StyledListPage>
        <StyledInnerListPage>
          <SearchFilter
            filter={patientFilter}
            callbackFun={changeFilter}
            onDateChange={handleDateFilter}
            searchText={searchText}
            searchInputPlaceholder={t("page.search_user_by")}
            selectedOption={filters}
          />
          <SelectedFilter
            handleClearSearch={handleClearSearch}
            handleClearDate={handleClearDate}
            selected={filters}
            formDate={date[0]}
            toDate={date[1]}
          />
          <PatientTable data={data} callback={fetchClient} />
          <ComponentPagination total={total} page={page.page} changePage={handlePagination} />
        </StyledInnerListPage>
      </StyledListPage>
    </>
  );
};
